import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import { ApiUrlConstant } from "../../../constants/api-url.constant";
import { GenericHttpService } from "../../../services/generic-http.service";
import { Observable, forkJoin, of } from "rxjs";
@Injectable({
  providedIn: 'root'
})
export class DataService {

  apiUrl = '';
  constructor(
    public genericHttp: GenericHttpService,
  ) {}

  getData(config, query): Observable<any> {
    const httpUrl = [];
      config.map(data => {
        httpUrl.push(this.genericHttp.httpRequest({
            url: `${environment.gateWayHost}${data.API}`,
            query: query,
            method: 'GET',
          }).pipe(catchError(error => of(error))));
      })
      return forkJoin(httpUrl);
  }
}
